import React, {Component} from 'react';


class Loader extends Component {
    render() {
        return (
            <div className="myLoader">
                <i className="fas fa-spinner fa-spin fz-25"></i> <p className="mgt-5">Please Wait</p>
            </div>
        )
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loader.js